import { getKey, callOpenAICompat } from './shared';
import { t } from '../modules/i18n';

export async function callDeepSeek(model, prompt, signal, opts) {
  const key = getKey("deepseek");
  if (!key) throw new Error(t("err.nokey", { provider: "DeepSeek" }));
  return callOpenAICompat("DeepSeek", "https://api.deepseek.com/v1/chat/completions", key, model, prompt, signal, opts);
}
